import { lazy } from "react";
import Loadable from "components/Loadable";

const IndustryList = Loadable(
  lazy(() => import("features/industry/components/List"))
);
const IndustryPage = Loadable(
  lazy(() => import("features/industry/components/Page"))
);

const routes = {
  path: "industry",
  children: [
    { path: "", element: <IndustryList /> },
    { path: "add", element: <IndustryPage /> },
    { path: "edit/:industryID?", element: <IndustryPage /> },
  ],
};

export default routes;
